// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__6BYQT","modal":"InfoModal_modal__7KGHg","btn_main":"InfoModal_btn_main__E-vxv"};